export default "__VITE_ASSET__Cj_HbIg6__"